export const yesNo = [
    { code: 'Y', label: 'Yes' },
    { code: 'N', label: 'No' },
];